import { useTenantMemberships } from '@/hooks/useTenantMemberships'
import { useTenant } from '@/lib/tenant'

/**
 * The current user's role in the currently-selected tenant — read from tenant memberships
 * rather than `authClient.useSession().user.role`, which mirrors better-auth's global
 * `User.role` and can be stale for a user with a different role in another tenant.
 * Returns `null` while memberships are still loading or no tenant is selected.
 */
export function useCurrentTenantRole(): string | null {
  const { tenantSlug } = useTenant()
  const { data: membershipsResult } = useTenantMemberships()
  const memberships = membershipsResult?.data ?? []

  return memberships.find((membership) => membership.slug === tenantSlug)?.role ?? null
}
